<template>
  <div class="br-pagebody pd-x-20 pd-sm-x-30">
    <div class="card bd-gray-400">
      <table class="table mg-b-0 table-contact bill data-table">
        <thead>
          <tr>
            <th>{{ $t("product.供应商名称") }}</th>
            <th>{{ $t("other.状态") }}</th>
            <th>{{ $t("product.时间") }}</th>
            <th>{{ $t("mall.留言内容") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.id">
            <td class="valign-middle">
              <span class="tx-white">{{ (item.distributor || {}).name }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{
                $t($dict.newProStatus[item.status])
              }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ dateFormat(item.createTime) }}</span>
            </td>
            <td class="valign-middle">
              <span class="tx-white">{{ item.remark || "---" }}</span>
            </td>
          </tr>
          <tr v-if="(!items || items.length < 1) && !first_loading">
            <td colspan="9">
              <div class="col-12 none-product">
                <i class="fa fa-ban"></i>{{ $t("mall.没有符合条件的数据") }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["first_loading", "items"],
  methods: {
    dateFormat(date) {
      if (!date) return "---";
      moment.locale("zh-cn");
      return moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>